// extracted by mini-css-extract-plugin
module.exports = {"hidden":"styles_hidden__MySjc"};